import _ from "underscore";

import { CAMPAIGNS_ENDPOINT } from "api/base";

import ContextModel from "./context";

var EventModel = ContextModel.extend({
    // Override Properties / Methods

    idAttribute: `eventId`,
    urlRoot: `${CAMPAIGNS_ENDPOINT}/events`,

    defaults: _.extend({ type: `event` }, ContextModel.prototype.defaults),

    constants: _.extend(
        {
            urlPrefix: `e`
        },
        ContextModel.prototype.constants
    )
});

export default EventModel;
